import type { Prospect } from "../types";
import { ProspectCreate } from "./ProspectCreate";
import { ProspectEdit } from "./ProspectEdit";
import { ProspectList } from "./ProspectList";
import { ProspectShow } from "./ProspectShow";

export default {
  list: ProspectList,
  show: ProspectShow,
  edit: ProspectEdit,
  create: ProspectCreate,
  recordRepresentation: (record: Prospect) => record?.owner_name,
};
